/* Print the language of each code block as a small label ("SQL", "JS") */
(function () {
    'use strict';

    var NAMES = {js: 'JavaScript', ts: 'TypeScript', sh: 'Shell', py: 'Python', rb: 'Ruby', yml: 'YAML'};

    document.querySelectorAll('.gh-content pre > code[class*="language-"]').forEach(function (code) {
        var match = code.className.match(/language-([\w+#-]+)/);
        if (!match) {
            return;
        }
        var lang = match[1].toLowerCase();
        code.parentElement.setAttribute('data-lang', NAMES[lang] || lang);
    });
})();
